import React from 'react';
import { useCanvasStore } from '@/store/canvas-store';
import { CANVAS_CONFIG } from '@/utils/constants';
import styles from './KeySegmentBands.module.css';

interface KeySegmentBandsProps {
  zoom: number;
  totalBeats: number;
}

// Muted warm tones from the Manuscript palette — subordinate to phrase backgrounds
const ZONE_COLORS = [
  'var(--manuscript-parchment, rgba(245, 235, 215, 0.35))',
  'var(--manuscript-sepia, rgba(190, 165, 130, 0.18))',
  'var(--manuscript-gilt, rgba(212, 175, 55, 0.12))',
  'var(--manuscript-walnut, rgba(140, 100, 60, 0.10))',
];

export const KeySegmentBands: React.FC<KeySegmentBandsProps> = ({ zoom, totalBeats }) => {
  const keySegments = useCanvasStore((s) => s.keySegments);

  if (!keySegments?.length) return null;

  const beatWidth = CANVAS_CONFIG.GRID_BEAT_WIDTH * zoom;

  return (
    <div className={styles.container}>
      {keySegments.map((seg, i) => {
        const left = seg.startBeat * beatWidth;
        const widthBeats =
          seg.endBeat == null
            ? Math.max(0, totalBeats - seg.startBeat)
            : Math.max(0, seg.endBeat - seg.startBeat);
        const width = Math.max(8, widthBeats * beatWidth);
        const label = `${seg.tonic} ${seg.mode === 'minor' ? 'min' : 'maj'}`;

        return (
          <div
            key={`ks-${i}-${seg.startBeat}`}
            data-key-segment="true"
            className={styles.zone}
            style={{ left: `${left}px`, width: `${width}px`, background: ZONE_COLORS[i % ZONE_COLORS.length] }}
          >
            <span className={styles.label}>{label}</span>
          </div>
        );
      })}
    </div>
  );
};
